import React from 'react';

const CaracteristicasPlacaTipoMarmol = () => {
  return (
    <section className="p-0 position-relative overflow-visible">
      <div className="container-fluid px-xxl-7">
        <div className="why-choose-style2 bg-dark rounded">
          <div className="row align-items-center align-content-center">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="mb-4 title-style5">
                <span className="sub-title">ideales para áreas húmedas como cocinas y baños</span>
                <h2 className="display-5 font-weight-800 text-white mb-0 lh-1">
                Ventajas de la placa tipo mármol rígida
                </h2>
              </div>
              <p className="mb-0 text-white opacity7 w-xl-90 w-xxl-80">
              Diseñadas con acabados de alta calidad, las placas tipo mármol de PVC replican con precisión el aspecto del mármol natural, brindando un toque de lujo a cualquier ambiente.
              </p>
            </div>
            <div className="col-lg-6 order-1 order-lg-2 mb-1-9 mb-md-2-5 mb-lg-0">
              <div className="why-choose-img1">
                <img src="/assets/img/productos/muro-placa-tipo-marmol/placa-tipo-marmol-ventajas.jpg" alt="Ventajas placa tipo mármol" className="rounded" />
              </div>
            </div>
          </div>

          {/* Tarjetas */}
          <div className="row pb-2-5 pb-lg-7 pt-1-9 pt-lg-5 mt-n1-9 border-bottom border-color-light-white-fifty why-choose-dots position-relative">
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Resistencia al Agua"
              descripcion="Su composición de PVC las hace completamente impermeables, sin preocuparse por filtraciones o deterioro."
              delay="200ms"
            />
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Durabilidad Extrema "
              descripcion="Resisten impactos, rayaduras y desgaste diario, manteniendo su apariencia impecable durante años."
              delay="400ms"
            />
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Fácil Instalación"
              descripcion="Gracias a su diseño liviano y práctico, las placas pueden instalarse rápidamente, reduciendo tiempos y costos en tus proyectos."
              delay="600ms"
            />
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Bajo Mantenimiento"
              descripcion="Su superficie lisa y no porosa facilita la limpieza y evita la acumulación de suciedad, manteniendo los espacios siempre relucientes."
              delay="800ms"
            />
          </div>

          {/* Sección final */}
          <div className="row mt-2-0 mt-lg-5 align-items-center position-relative z-index-9">
            <div className="col-lg-8 mb-1-9 mb-lg-0">
              <div className="text-start">
                <h3 className="mb-0 text-white h4">
                Te asesoramos en tu proyecto. ¡Cuéntanos qué superficie deseas cubrir!</h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="text-start text-lg-end">
                <a href="contacto-decototal" className="butn-style7 secondary medium rounded">
                Contáctanos ahora
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente para las tarjetas
const Tarjeta = ({ imgSrc, titulo, descripcion, delay }) => {
  return (
    <div className={`col-md-6 col-xl-3 mt-1-9 wow fadeInUp`} data-wow-delay={delay}>
      <div className="card card-style22 border-0 bg-transparent">
        <div className="h-100">
          <div className="card-img">
            <img src={imgSrc} alt="..." className="w-60px" />
          </div>
          <div className="card-title">
            <h3 className="text-white h4">{titulo}</h3>
          </div>
          <p className="mb-0 text-white opacity7">{descripcion}</p>
        </div>
      </div>
    </div>
  );
};

export default CaracteristicasPlacaTipoMarmol;
